import axios from "axios";
import { useEffect, useState } from "react";
import Box from "elements/Box";
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ProjectConfig } from "Global";
import AlertDialog from "elements/AlertDialog";
import AddIcon from "@mui/icons-material/Add";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useSnackbar } from "notistack";

import "assets/css/main.css";

import ReasonsEditor from "./ReasonsEditor";
import EventsEditor from "./EventsEditor";
import { ApiRequest } from "GlobalFunctions";

export default function OrdersConceptList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => {
    setLoading(false);
  }, []);

  // States for Reasons
  const [reasonsList, setReasonsList] = useState<any[]>([]);
  const [reasonsTotalPages, setReasonsTotalPages] = useState(0);
  const [reasonsPage, setReasonsPage] = useState(1);
  const [openReasonsEditor, setOpenReasonsEditor] = useState(false);
  const [activeReason, setActiveReason] = useState<any>(null);
  const [openReasonsAlert, setOpenReasonsAlert] = useState(false);

  // States for Events
  const [eventsList, setEventsList] = useState<any[]>([]);
  const [eventsTotalPages, setEventsTotalPages] = useState(0);
  const [eventsPage, setEventsPage] = useState(1);
  const [openEventsEditor, setOpenEventsEditor] = useState(false);
  const [activeEvent, setActiveEvent] = useState<any>(null);
  const [openEventsAlert, setOpenEventsAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadReasonsList();
  }, [reasonsPage]);

  useEffect(() => {
    setLoading(true);
    loadEventsList();
  }, [eventsPage]);

  const loadReasonsList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/orders-concepts/list_reasons",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: reasonsPage,
      },
      setResponse: (response: any) => {
        setReasonsList(response.list);
        setReasonsTotalPages(response.total_pages);
        setLoading(false);
      },
    });

    // localStorage.setItem("reasonsPage", reasonsPage.toString());
  };

  const loadEventsList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/orders-concepts/list_events",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: eventsPage,
      },
      setResponse: (response: any) => {
        setEventsList(response.list);
        setEventsTotalPages(response.total_pages);
        setLoading(false);
      },
    });

    // localStorage.setItem("eventsPage", eventsPage.toString());
  };

  const handleDeleteReason = (reason_id: number) => {
    setActiveReason(reason_id);
    setOpenReasonsAlert(true);
  };

  const deleteReason = () => {
    const body = JSON.stringify({
      reason_id: activeReason,
    });

    axios
      .post(ProjectConfig.api_url + "/orders-concepts/deleteItem_reasons", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar("Razón eliminada con éxito", { variant: "success" });
          loadReasonsList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenReasonsAlert(false);
      });
  };

  const handleDeleteEvent = (event_id: number) => {
    setActiveEvent(event_id);
    setOpenEventsAlert(true);
  };

  const deleteEvent = () => {
    const body = JSON.stringify({
      event_id: activeEvent,
    });

    axios
      .post(ProjectConfig.api_url + "/orders-concepts/deleteItem_events", body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.status === "success") {
          enqueueSnackbar("Evento eliminado con éxito", { variant: "success" });
          loadEventsList();
        }
      })
      .catch((err) => {
        console.log(err.data);
      })
      .finally(() => {
        setOpenEventsAlert(false);
      });
  };

  return (
    <div id="OrdersConceptList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Conceptos de órdenes</h2>
            <span className="h2_subtitle">Lista de conceptos de órdenes</span>
          </div>
        </div>

        {/* REASONS SECTION */}
        <Box id="ReasonsListIn" className="box100" style={{ marginBottom: "30px" }}>
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <Typography variant="h6" component="h3" style={{ margin: "10px 0" }}>
                RAZONES
              </Typography>
            </div>
            <div className="boxContainerActions">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setActiveReason(null);
                  setOpenReasonsEditor(true);
                }}
                startIcon={<AddIcon />}
              >
                Crear razón
              </Button>
            </div>
          </div>

          <TableContainer>
            <Table aria-label="reasons table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID DE LA COMPAÑÍA</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>RAZÓN</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reasonsList.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.reason_id}</TableCell>
                    <TableCell>{item.company_id}</TableCell>
                    <TableCell>{item.reason}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveReason(item.reason_id);
                          setOpenReasonsEditor(true);
                        }}
                      >
                        Editar
                      </Button>
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDeleteReason(item.reason_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={reasonsTotalPages}
            page={reasonsPage}
            onChange={(event, value) => setReasonsPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>

        {/* EVENTS SECTION */}
        <Box id="EventsListIn" className="box100">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <Typography variant="h6" component="h3" style={{ margin: "10px 0" }}>
                EVENTOS
              </Typography>
            </div>
            <div className="boxContainerActions">
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setActiveEvent(null);
                  setOpenEventsEditor(true);
                }}
                startIcon={<AddIcon />}
              >
                Crear evento
              </Button>
            </div>
          </div>

          <TableContainer>
            <Table aria-label="events table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID DE LA COMPAÑÍA</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>EVENTO</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {eventsList.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.event_id}</TableCell>
                    <TableCell>{item.company_id}</TableCell>
                    <TableCell>{item.event}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        startIcon={<ModeEditIcon />}
                        onClick={() => {
                          setActiveEvent(item.event_id);
                          setOpenEventsEditor(true);
                        }}
                      >
                        Editar
                      </Button>
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDeleteEvent(item.event_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={eventsTotalPages}
            page={eventsPage}
            onChange={(event, value) => setEventsPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      {/* Alert Dialogs */}
      <AlertDialog
        open={openReasonsAlert}
        setOpen={setOpenReasonsAlert}
        subtitle="¿Está seguro que desea eliminar esta razón?"
        send={deleteReason}
      />

      <AlertDialog
        open={openEventsAlert}
        setOpen={setOpenEventsAlert}
        subtitle="¿Está seguro que desea eliminar este evento?"
        send={deleteEvent}
      />

      {/* Editors */}
      <ReasonsEditor
        setLoading={setLoading}
        openEditor={openReasonsEditor}
        setOpenEditor={setOpenReasonsEditor}
        reason_id={activeReason}
        loadList={loadReasonsList}
      />

      <EventsEditor
        setLoading={setLoading}
        openEditor={openEventsEditor}
        setOpenEditor={setOpenEventsEditor}
        event_id={activeEvent}
        loadList={loadEventsList}
      />
    </div>
  );
}
